import { toValue } from 'vue';

import type { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  regex: RegExp;
  /** A custom message is required in order to inform the user of the required pattern. */
  message: ValidationMessage;
}

export default function pattern(config: Config): ValidationRule {
  return {
    name: 'pattern',
    validator(_value) {
      const value = toValue(_value);

      return !isDefined(value) || config.regex.test(String(value));
    },
    message: () => {
      if (typeof config.message !== 'string' || !config.message.trim()) {
        throw new Error(
          'The "pattern" ruleFactory requires a custom message informing the user of the required pattern.',
        );
      }

      return config.message;
    },
  };
}
